import { useForm } from "@refinedev/antd";
import { HttpError, useCreate, useNavigation } from "@refinedev/core";
import { Collapse, Form, Input } from "antd";
import { IntelligenceSearchList } from "./list";
import { PayloadConfigType, SaveConfigComponent } from "./component/crud/save-config-component";
import { TitleConfig } from "./component/crud/title-config";
import { IntelligenceFormFieldsEnum } from "./enum";
import dayjs from "dayjs";
import { DEFAULT_LIMIT } from "./component/search-component/order-limit";
import { CrudCollapseStyle } from "@src/components/crud-collapse-style";
import { ButtonBackToListing } from "@src/components/crud-explore/button-back-to-listing";

export const DEFAULT_TITLE = "Intelligence Search";
export const IntelligenceSearchCreate = () => {
  const { replace } = useNavigation();
  const { form } = useForm<any, HttpError, any>();

  const { mutateAsync: createISConfig, isLoading: isLoadingCreateISConfig } = useCreate();

  const handleCreate = async (payload: PayloadConfigType, cb?: () => void) => {
    const explorationConfig = await createISConfig({
      resource: "explorations",
      values: payload,
      dataProviderName: "nestjsx",
      successNotification: {
        type: "success",
        message: "Successfully created",
        description: "Your explore have been created",
      },
      meta: {
        headers: {
          "product-code": payload.product_code,
        },
      },
    });
    cb?.();
    if (explorationConfig.data?.id) {
      replace(`/explorations/intelligence-search/${explorationConfig.data?.id}`);
    }
  };
  return (
    <CrudCollapseStyle>
      <Collapse
        expandIcon={() => <ButtonBackToListing />}
        activeKey={["intelligence-search"]}
        items={[
          {
            key: "intelligence-search",
            label: (
              <div className="flex justify-between">
                <TitleConfig form={form} />
                <SaveConfigComponent
                  isOwnerConfig={false}
                  form={form}
                  isCreate
                  handleSave={handleCreate}
                  isLoading={isLoadingCreateISConfig}
                />
              </div>
            ),
            children: (
              <Form
                form={form}
                layout="vertical"
                initialValues={{
                  [IntelligenceFormFieldsEnum.TITLE]: DEFAULT_TITLE,
                  [IntelligenceFormFieldsEnum.DESCRIPTION]: "",
                  [IntelligenceFormFieldsEnum.TIME_RANGE]: [dayjs().add(-15, "d"), dayjs().add(-1, "d")],
                  [IntelligenceFormFieldsEnum.QUERY_LIMIT]: DEFAULT_LIMIT,
                }}
              >
                <IntelligenceSearchList form={form} isCreate />
                <Form.Item name={IntelligenceFormFieldsEnum.TITLE} hidden>
                  <Input />
                </Form.Item>
                <Form.Item name={IntelligenceFormFieldsEnum.DESCRIPTION} hidden>
                  <Input />
                </Form.Item>
              </Form>
            ),
          },
        ]}
      />
    </CrudCollapseStyle>
  );
};
